import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { FaShoppingCart } from "react-icons/fa";
import { window } from "browser-monads";

const Cart = (props) => {
  useEffect(() => {
    document.addEventListener("snipcart.ready", function() {});
    return () => {
      document.removeEventListener("snipcart.ready", function() {});
    };
  });

  let count = window.Snipcart.api.items.count();

  return (
    <div
      style={{
        position: "fixed",
        right: 0,
        zIndex: 10,
      }}
    >
      <div
        className="snipcart-summary"
        style={{
          backgroundColor: "#000",
          border: "none",
          width: "180px",
          height: "40px",
          color: "#fff",
        }}
      >
        <button
          className="snipcart-checkout mr-3"
          style={{
            backgroundColor: "transparent",
            border: "none",
            color: "#fff",
          }}
        >
          <FaShoppingCart />
        </button>
        Items: <span class="snipcart-total-items">{count}</span>
      </div>
    </div>
  );
};

Cart.propTypes = {};

export default Cart;
